import React, { useEffect, useState } from "react";
import {
  LineChart, Line, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer
} from "recharts";
import axios from "axios";

const formatYAxis = (val) => {
  if (Math.abs(val) >= 1e9) return `${(val / 1e9).toFixed(1)}B`;
  if (Math.abs(val) >= 1e6) return `${(val / 1e6).toFixed(1)}M`;
  return val;
};

function AnimatedChartPreview() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const metric = "Assets"; // You can change to NetIncome, EBITDA, etc.
  const entity = "AAPL";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/financials/${entity}`, {
          params: { metrics: metric }
        });

        const raw = res.data
          .filter(d => d.Metric === metric)
          .sort((a, b) => new Date(a.FiledDate) - new Date(b.FiledDate))
          .slice(-6); // Last 6 quarters

        const transformed = raw.map(d => ({
          date: new Date(d.FiledDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
          }),
          value: Number(d.Value)
        }));

        setData(transformed);
      } catch (err) {
        console.error("Error loading preview data:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="mx-auto max-w-3xl w-full bg-white rounded shadow-md p-4">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">AAPL Revenue (Last 6 Quarters)</h3>
      {loading ? (
        <p className="text-gray-500">Loading chart...</p>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis tickFormatter={formatYAxis} />
            <Tooltip formatter={formatYAxis} />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#4f46e5"
              strokeWidth={3}
              dot={{ r: 4 }}
              animationDuration={2000}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export default AnimatedChartPreview;
